import React from 'react';
import { Vacacional } from './descansos/Vacacional';
import { HorariosExtraLogsSection } from './horariosExtra/HorariosExtraLogsSection';

export const Descansos = ({objProfesional, setObjProfesional, descansosObj, descansosTemp, setDescansosTemp, editMode, deleteVacaciones, horariosExtraTemp, setHorariosExtraTemp, deleteHorarioExtra}) => {

    const profesionalId = objProfesional.usuario || objProfesional._id;
    const empresa = objProfesional.empresa;

    return (
        <div className='descansos'>
            {
                <Vacacional
                    objProfesional={ objProfesional }
                    setObjProfesional={ setObjProfesional }
                    editMode={ editMode }
                    descansosObj={ descansosObj }
                    descansosTemp={ descansosTemp }
                    setDescansosTemp={ setDescansosTemp }
                    deleteVacaciones={ deleteVacaciones }
                    horariosExtraTemp={ horariosExtraTemp }
                    setHorariosExtraTemp={ setHorariosExtraTemp }
                    deleteHorarioExtra={ deleteHorarioExtra }
                />
            }
            <HorariosExtraLogsSection 
                profesionalId={profesionalId}
                empresa={empresa}
            />
        </div>
    )
}
